import styled, { css, keyframes } from "styled-components";
import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";

export const ModalContainer = styled.div`
  width: 100%;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  max-height: 90dvh;
  border-radius: 24px;
  border: 1px solid #142743;
  background: #0a1424;
  position: relative;
  height: 100%;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

export const ModalTitle = styled.h2`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;

  font-weight: 600;

  letter-spacing: -0.09px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
`;
const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: 7px;
  width: 100%;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  color: #fff;

  &:hover {
    opacity: 0.7;
  }
`;
export const CategoryItem = styled.div`
  display: flex;
  align-items: center;
  min-width: ${({ $width }) => $width && `${$width}px`};
  justify-content: center;
  height: 32px;
  gap: 8px;
  background-color: ${({ $selected }) => ($selected ? "#345884" : "#112238")};
  border-radius: 8px;
  border: 1px solid #345884;

  cursor: pointer;

  ${({ $animation }) =>
    $animation &&
    css`
      background: linear-gradient(
        90deg,
        #152a47 0px,
        #23406a 40px,
        #152a47 80px
      );
      background-size: 468px 100%;
      animation:
        ${shimmer} 3s infinite linear,
        ${pulse} 2s infinite ease-in-out;
    `}
`;
export const ModalContent = styled.div`
  padding: 16px;

  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  text-align: center;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const ModalMessage = styled.p`
  color: #fff;
  text-align: left;
  font-family: Figtree;
  font-size: 14px;
  opacity: 0.5;
  font-weight: 400;
  line-height: 21px; /* 133.333% */
`;

export const ModalLabel = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  letter-spacing: -0.21px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 40rem;
`;
export const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  gap: 12px;
`;

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  width: 100%;
`;
export const Select = styled.div`
  display: flex;
  height: 44px;
  padding: 12px;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;
  width: 100%;

  cursor: pointer;
`;

export const IconWrapper = styled.div`
  height: 44px;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
`;

export const SelectValue = styled.span`
  color: #fff;
  font-family: Figtree;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  letter-spacing: -0.07px;

  display: -webkit-box;
  -webkit-line-clamp: 1; /* Maksimalno 3 reda */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const SelectList = styled.div`
  display: flex;
  width: 100%;
  position: absolute;
  padding: 16px 14px;
  z-index: 2;
  flex-direction: column;
  left: 0;
  right: 0;
  top: calc(17px + 44px + 16px);

  max-height: calc(20px * 10 + 16px * 9 + 32px);
  overflow: auto;

  border-radius: 16px;
  border: 1px solid #345884;
  background: #142743;
`;

export const SelectListItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding-top: 8px;
  padding-bottom: 8px;

  transition: all 0.3s ease-in-out;

  &:hover {
    padding-left: 8px;
  }

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }
`;

export const SelectListValue = styled.span`
  font-family: Figtree;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const CancelButton = styled.button`
  display: flex;
  width: 110px;
  height: 40px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: transparent;
  border: none;
  outline: none;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;
  width: 100%;
  transition: all 0.3s ease;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
export const CloseIconWrapper = styled.div`
  height: 100%;
  width: 44px;
  transition: opacity 0.3s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;
export const CloseIcon = styled(CloseSvg)``;

export const InfoIconWrapper = styled(IconWrapper)``;
export const SearchFilter = styled.div`
  display: flex;
  height: 32px;
  padding: 0 8px 0 11px;
  align-items: center;
  border-radius: 8px;

  border: 1px solid #345884;
  background: #112238;

  cursor: ${(props) => (props.$expanded ? "default" : "pointer")};

  width: ${(props) => (props.$expanded ? "230px" : "44px")};
  transition:
    width 0.6s cubic-bezier(0.23, 1, 0.32, 1),
    background 0.3s ease,
    opacity 0.3s ease;

  @media (max-width: 768px) {
    min-width: ${(props) => (props.$expanded ? "230px" : "44px")};
    transition:
      min-width 0.6s cubic-bezier(0.23, 1, 0.32, 1),
      background 0.3s ease,
      opacity 0.3s ease;
  }

  @media (max-width: 480px) {
    width: ${(props) => (props.$expanded ? "230px" : "44px")};
  }
  position: relative;
`;

export const StyledInput = styled.input`
  background-color: blue;
  width: 100%;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.07px;
  padding-left: 30px;
  z-index: 2;

  &::placeholder {
    color: #fff;
    opacity: 0.5;
  }
`;
export const TooltipContainer = styled.div`
  border-radius: 16px;
  border: 1px solid #142743;
  background: #081120;
  padding: 16px;
  position: absolute;
  bottom: calc(100% + 12px);
  right: 0;
  width: 350px;
  z-index: 100;

  @media (max-width: 480px) {
    width: 280px;
    right: -8px;
  }
`;

export const TooltipText = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.07px;
`;

export const GenerateContainerMobile = styled.div`
  display: flex;
  align-items: center;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const ConfirmButton = styled.button`
  display: flex;
  min-width: 110px;
  height: 40px;
  width: 100%;
  padding: 0 20px;
  justify-content: center;
  align-items: center;

  gap: 4px;
  border-radius: 100px;
  background: ${({ $type }) => {
    switch ($type) {
      case "danger":
        return "linear-gradient(135deg, #ff4757, #ff3838)";
      case "success":
        return "linear-gradient(135deg, #2877D9, #c4057a)";
      case "primary":
      default:
        return "#fff";
    }
  }};
  border: none;
  outline: none;

  color: ${({ $type }) => ($type === "primary" ? "#081120" : "#ffffff")};
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: ${({ $type }) => {
      switch ($type) {
        case "danger":
          return "0 4px 15px rgba(255, 71, 87, 0.3)";
        case "success":
          return "0 4px 15px rgba(163, 0, 94, 0.3)";
        case "primary":
        default:
          return "0 4px 15px rgba(0, 0, 0, 0.1)";
      }
    }};
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const ContentContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  min-height: 0;
  /* padding-inline: 16px; */
  overflow-y: auto;
`;
export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  text-align: center;
  flex: 1;

  h3 {
    font-size: 24px;
    color: white;
    margin-bottom: 12px;
    font-family: Figtree;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
    max-width: 400px;
    font-family: Figtree;
    color: white;
    opacity: 0.6;
    margin-bottom: 24px;
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 4px;
  flex: 1;
  height: fit-content;
`;

export const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const PaginationWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  padding: 6px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  right: 8px;
  /* top: 28px; */
  top: 8px;
  gap: 10px;
  max-width: 32px;
  max-height: 32px;
  z-index: 2;
`;
